module.exports = __webpack_public_path__ + "img/box9-10.6de10147.png";